import React from 'react';
import {Helmet} from 'react-helmet';
import Typography from '@material-ui/core/Typography'
import{
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import Img from 'gatsby-image'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import PageTitle from '../../components/page-title'


import HorizontalCard from '../../components/horizontal-card';

export default class InitiativesPage extends React.Component{
    render(){
	let features = this.props.data;
	console.log(features);
	let initiatives = [
	    {
		title: "Feed the Rock Survey",
		featuredImage: features.rock,
		description: "We harness the power of memes to gather statistical data on unused meal plans in a viral, self propagating way. The scale of unused swipes is made more accessible by translating first into the Big Mac Index and then to a professional wrestler's 4,000 calorie a day diet."
	    },
	    {
		title: "Open Kitchen",
		featuredImage: features.open_kitchen,
		description: "The Open Kitchen is a series of free community cooking classes where we show students foundational skills in cooking, sanitation, nutrition, and shopping. Each class is centered around  a cultural cuisine and after we cook together, we eat together."
	    },
	    {
		title: "Packathon",
		featuredImage: features.packathon,
		description: "We redirect excess club funding to purchase ingredients and pack 150+ sandwiches for our fellow students. We stock existing community fridges around campus as a way to provide extra nutrition during stressful times, like final exams."
	    },
	    /*
	    {
		title: "Love Through Food",
		featuredImage: features.lovethroughfood,
		description: "something"
	    },
	    */
	    {
		title: "Trailblazers",
		featuredImage: features.trailblazers,
		description: "Undergraduate students learn the skills to plan, communicate, and execute change in social impact areas they are passionate about. They attend closely crafted workshops and travel across the country to lead workshops themselves.",
		link: "/trailblazers"
	    },
	    /*
	    {
		title: "Hunger Action Series",
		featuredImage: features.has,
		description: "something"
	    },
	    {
		title: "Smart Pantry",
		featuredImage: features.packathon,
		description: "something"
	    }
	    */
	    
	];
	return(
	    <div style={this.props.transition && this.props.transition.style}
		 className="section white slim">
		<Helmet>
		    <title>
			Initiatives | Share Meals
		    </title>
		</Helmet>
		<PageTitle 
			titles={{
				title: "Our Initiatives",
			}}
		/>
		<Grid style={{paddingTop: "2rem"}}>
		    <Row>
			{initiatives.map(function(initiative, index){
			     return(
				 <Col md={12}
				      lg={6}
				      key={index}
				      style={{marginTop: "8px",
					      marginBottom: "8px"
				      }}>
				     <HorizontalCard
					 image={initiative.featuredImage ?
						initiative.featuredImage.childImageSharp.sizes.src
					      : null}
					 imagePadding={0}
					 title={initiative.title}>
					     <p>
						 {initiative.description} {initiative.link ? <a href={initiative.link}>Read More</a> : ''}
					     </p>
				     </HorizontalCard>
				 </Col>
			     )
			 })}
		    </Row>
		</Grid>
	    </div>
	);
    }
}

export const query = graphql`
    query initiativesQuery{
	rock: file(relativePath:{ eq: "initiatives/feature_images/rock.png"}){
	    childImageSharp{
		sizes(
		    maxWidth: 500,
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	},
	open_kitchen: file(relativePath:{ eq: "initiatives/feature_images/open_kitchen.png"}){
	    childImageSharp{
		sizes(
		    maxWidth: 500,
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	},
	lovethroughfood: file(relativePath:{ eq: "initiatives/feature_images/lovethroughfood.jpg"}){
	    childImageSharp{
		sizes(
		    maxWidth: 500,
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	},
	trailblazers: file(relativePath:{ eq: "initiatives/feature_images/trailblazers.png"}){
	    childImageSharp{
		sizes(
		    maxWidth: 500,
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	},
	packathon: file(relativePath:{ eq: "initiatives/feature_images/packathon.png"}){
	    childImageSharp{
		sizes(
		    maxWidth: 500,
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	}

    }`



// WEBPACK FOOTER //
// ./src/pages/initiatives/index.jsx